import { Injectable } from '@angular/core'
import { Actions, createEffect, ofType } from '@ngrx/effects'
import { normalizeHttpError, SiteContextActions, withdrawOn } from '@spartacus/core'
import { of } from 'rxjs'
import { catchError, map, mergeMap, withLatestFrom } from 'rxjs/operators'
import { MbCartMigrationConnector } from '../../connectors'
import { MbCartActions } from '../actions'
import { UserAccountFacade } from '@spartacus/user/account/root'
import { CartActions } from '@spartacus/cart/base/core'

@Injectable({
  providedIn: 'root'
})
export class MbCartEffects {

  private contextChange$ = this.actions$.pipe(
    ofType(
      SiteContextActions.CURRENCY_CHANGE,
      SiteContextActions.LANGUAGE_CHANGE
    )
  )

  migrateCart$ = createEffect(() => this.actions$.pipe(
    ofType(MbCartActions.MIGRATE_CART),
    map((action: MbCartActions.MigrateCart) => action?.payload),
    mergeMap(payload => this.mbCartMigrationConnector.post(payload?.userId, payload?.cartMigrationInfo).pipe(
      withLatestFrom(this.userService.get()),
      mergeMap(([migratedCart, user]) => {
        if (payload?.cartMigrationInfo?.willChangeBaseSite) {
          return [
            new MbCartActions.MigrateCartSuccess({
              migratedCart: migratedCart,
              isLoginProcess: payload?.isLoginProcess || false,
              user: user
            })
          ]
        } else {
          return [
            new MbCartActions.MigrateCartSuccess({
              migratedCart: migratedCart,
              isLoginProcess: payload?.isLoginProcess || false,
              user: user
            }),
            new CartActions.LoadCart({
              userId: payload?.userId,
              cartId: payload?.isLoginProcess && migratedCart?.code || payload?.cartId,
              extraData: { active: true }
            })
          ]
        }
      }),
      catchError(error => of(new MbCartActions.MigrateCartFail(normalizeHttpError(error))))
      )
    ),
    withdrawOn(this.contextChange$)
  ))

  constructor (protected actions$: Actions,
               protected mbCartMigrationConnector: MbCartMigrationConnector,
               protected userService: UserAccountFacade) { }
}
